module.exports = __webpack_public_path__ + "static/media/portfolio-img3.8efec0e1.jpg";